import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "1-trend-04-bottomleft",
  "use": "1-trend-04-bottomleft-usage",
  "viewBox": "0 0 1000 1000",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1000 1000\" xmlns=\"http://www.w3.org/2000/svg\" id=\"1-trend-04-bottomleft\">\n  <path d=\"M259.774 362.57v364.149c0 28.44 23.051 51.491 51.491 51.491h364.149c28.44 0 51.491-23.051 51.491-51.491s-23.051-51.491-51.491-51.491h-239.829l349.073-349.073c20.119-20.119 20.119-52.711 0-72.831s-52.711-20.119-72.831 0l-349.073 349.073v-239.829c0.001-14.202-5.754-27.093-15.076-36.415s-22.195-15.094-36.415-15.076c-28.44 0-51.491 23.051-51.491 51.491z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol